export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_USER = "updateUser";
export const DATA_USER = "dataUser";

export const CHECK_AUTH = "checkAuth";
export const FETCH_LASTTRANSACTIONS = "lastTransactions";
export const FETCH_PROFILE = "profile";
export const FETCH_COMPANIES = "fetchCompanies";

export const FETCH_CARRIERS = "fetchCarriers";
export const FETCH_BANKS = "fetchBanks";

export const REQUEST_BUY = "requestBuy";
export const FETCH_BUYS = "fetchBuys";
export const FETCH_ADMINBUYS = "fetchAdminBuys";
export const PROCESS_BUYS = "processBuys";
export const PAY_DEBT = "payDebts";

export const FETCH_ADMINCONSIGNMENTS = "fetchAdminConsignments";
export const REQUEST_CONSIGNMENTMANUAL = "requestConsignmentManual";
export const FETCH_CONSIGNMENTS = "fetchConsignments";
export const REPORT_CONSIGNMENT = "reportConsignments";
export const PROCESS_CONSIGNMENTS = "processConsignmnets";
export const UPLOAD_FILE = "uploadFile";
